import Vue from 'vue'
import Vuex from 'vuex'

import { ITagsViewState } from './modules/tagsView'
import {IMenuItem} from "@/store/modules/menu";

export interface IRootState {
  menus: Map<number, Map<string, IMenuItem>>,
  tagsView?: ITagsViewState,
  originToken: any,
  userRights: any,
  Authorization: any,
  AuthedUser: any,
  AuthedTeacher: any,
  CurrentSubject: any,
  isEditted: boolean,
  imported: number,  //基础数据是否全部导入过
  detect: number,   //是否勾选了弹出
  Region: any, //省市区数据
}

Vue.use(Vuex)

const parseMenus = (map: Map<string, IMenuItem>, menus: IMenuItem[]) => {
  menus.forEach(m => {
    map.set(m.url, m);
    if(m.children && m.children.length > 0){
      parseMenus(map, m.children);
    }
  })
}

export default new Vuex.Store<IRootState>({
  state: {
    menus: new Map(),
    originToken: sessionStorage.getItem('originToken') ? sessionStorage.getItem('originToken') : '',
    userRights: sessionStorage.getItem('userRights') ? JSON.parse(sessionStorage.getItem('userRights') as string) : null,
    Authorization: sessionStorage.getItem('Authorization') ? sessionStorage.getItem('Authorization') : '',
    AuthedUser: sessionStorage.getItem('AuthedUser') ? JSON.parse(sessionStorage.getItem('AuthedUser') as string) : null,
    AuthedTeacher: sessionStorage.getItem('AuthedTeacher') ? JSON.parse(sessionStorage.getItem('AuthedTeacher') as string) : null,
    CurrentSubject: sessionStorage.getItem('CurrentSubject') ? JSON.parse(sessionStorage.getItem('CurrentSubject') as string) : null,
    isEditted: false,
    imported: sessionStorage.getItem('imported') ? JSON.parse(sessionStorage.getItem('imported') as string) : 0,  //基础数据是否全部导入过
    detect: sessionStorage.getItem('detect') ? JSON.parse(sessionStorage.getItem('detect') as string) : 0,   //是否勾选了弹出
    Region: localStorage.getItem('Region') ? localStorage.getItem('Region') : null, //省市区数据
  },
  mutations: {
    pushMenu(state, moduleMenu){
      const menusMap = new Map<string, IMenuItem>();
      parseMenus(menusMap, moduleMenu.menus);
      state.menus.set(moduleMenu.moduleId, menusMap);
    },
    changeLogin (state, user) {
      state.Authorization = user.token;
      state.AuthedUser = user.userDetail;
      sessionStorage.setItem('hasCheckedPasswordExpiry', "0");
      sessionStorage.setItem('Authorization', user.token);
      sessionStorage.setItem('AuthedUser', JSON.stringify(user.userDetail));
      // sessionStorage.setItem('imported', JSON.stringify(user.imported));
      // sessionStorage.setItem('detect', JSON.stringify(user.detect));
      // state.imported = user.imported;
      // state.detect = user.detect;
    },
    saveToken (state, token) {
      //原始token
      state.originToken = token;
      sessionStorage.setItem('originToken', token);
    },
    changeUserRight (state, userRights) {
      //权限列表
      state.userRights = userRights;
      sessionStorage.setItem('userRights', JSON.stringify(userRights));
    },
    updateTeacherData(state, teacher){
      state.AuthedTeacher = teacher;
      if(teacher.subjects && teacher.subjects.length > 0){
        state.CurrentSubject = teacher.subjects[0];
      } else {
        state.CurrentSubject = {};
      }
      sessionStorage.setItem('AuthedTeacher', JSON.stringify(teacher));
      sessionStorage.setItem('CurrentSubject', JSON.stringify(state.CurrentSubject));
    },
    updateCurrentSubject(state, subject){
      state.CurrentSubject = subject;
      sessionStorage.setItem('CurrentSubject', JSON.stringify(state.CurrentSubject));
    },
    saveRegion(state , region){//省市区保存
      localStorage.setItem("Region", region);
    },
    signout(state){
      sessionStorage.removeItem('Authorization');
      sessionStorage.removeItem('AuthedUser');
      sessionStorage.removeItem('AuthedTeacher');
      sessionStorage.removeItem('CurrentSubject');
      state.AuthedUser = null;
      state.Authorization = '';
    }
  },
  modules: {
  }
})
